import { US, CA } from 'country-flag-icons/react/1x1';
import { currentUser } from '../../../utils/Auth/auth';

export const refundContacts = {
  1: 'ruslana.lesiuk@meest.com',
  2: 'oleksandr.prolohaiev@meest.com',
  4: 'paulshuliga@hotmail.com',
};

export const branchOptions = [
  {
    value: '1',
    label: '1 - Canada',
    isDisabled:
      !currentUser?.branches?.includes('1') &&
      !currentUser?.baseBranch?.includes('1'),
  },
  {
    value: '2',
    label: '2 - New Jersey',
    isDisabled:
      !currentUser?.branches?.includes('2') &&
      !currentUser?.baseBranch?.includes('2'),
  },
  {
    value: '4',
    label: '4 - Chicago',
    isDisabled:
      !currentUser?.branches?.includes('4') &&
      !currentUser?.baseBranch?.includes('4'),
  },
];

export const branchOptionsCalifnorniaIncluded = [
  {
    value: '1',
    label: '1 - Canada',
    isDisabled:
      !currentUser?.branches?.includes('1') &&
      !currentUser?.baseBranch?.includes('1'),
  },
  {
    value: '2',
    label: '2 - New Jersey',
    isDisabled:
      !currentUser?.branches?.includes('2') &&
      !currentUser?.baseBranch?.includes('2'),
  },
  {
    value: '3',
    label: '3 - Los Angeles',
    isDisabled:
      !currentUser?.branches?.includes('3') &&
      !currentUser?.baseBranch?.includes('3'),
  },
  {
    value: '4',
    label: '4 - Chicago',
    isDisabled:
      !currentUser?.branches?.includes('4') &&
      !currentUser?.baseBranch?.includes('4'),
  },
];

export const branchNames = {
  1: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Toronto, ON, Canada`}</div>
      <div className="sm:hidden inline-block">{`Toronto`}</div>
      <CA
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
  2: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Port Reading, New Jersey, USA`}</div>
      <div className="sm:hidden inline-block">{`Port Reading`}</div>
      <US
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
  4: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Chicago, IL, USA`}</div>
      <div className="sm:hidden inline-block">{`Chicago`}</div>
      <US
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
};

export const branchNamesCaliforniaIncluded = {
  1: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Toronto, ON, Canada`}</div>
      <div className="sm:hidden inline-block">{`Toronto`}</div>
      <CA
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
  2: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Port Reading, NJ, USA`}</div>
      <div className="sm:hidden inline-block">{`Port Reading`}</div>
      <US
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
  3: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Los Angeles, CA, USA`}</div>
      <div className="sm:hidden inline-block">{`Los Angeles`}</div>
      <US
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
  4: (
    <span className="flex items-center">
      <div className="hidden sm:inline-block">{`Chicago, IL, USA`}</div>
      <div className="sm:hidden inline-block">{`Chicago`}</div>
      <US
        title="United States"
        className="inline-block w-[0.6rem] h-[0.3rem] md:w-[0.8rem] md:h-[0.5rem] xl:w-5 xl:h-3 mx-1"
      />
    </span>
  ),
};
